import React, { useEffect, useState } from "react";
import { getVoteResults } from "../../../services/voteServices";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { toast } from "react-toastify";
import Button from "../../../components/Button/Button";
import { FaTimes } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";

const COLORS = [
  "#4285F4",
  "#FBBC05",
  "#34A853",
  "#EA4335",
  "#9C27B0",
  "#00ACC1",
];

const VoteResultsModal = ({ isOpen, onClose, voteId, voteTitle }) => {
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (isOpen && voteId) {
      fetchResults();
    }
  }, [isOpen, voteId]);

  const fetchResults = async () => {
    try {
      const data = await getVoteResults(voteId);
      setResults(data.results || []);
    } catch (error) {
      toast.error("Erreur lors du chargement des résultats");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="modal-box bg-white dark:bg-slate-200 max-w-4xl w-full p-6 rounded-lg shadow-lg overflow-y-auto max-h-[90vh]">
        <h2 className="text-2xl font-bold text-center mb-2 text-primary">
          Résultats : {voteTitle}
        </h2>

        {results.map((q, index) => (
          <div
            key={q.question_id}
            className="mb-10 p-4 border rounded shadow-sm bg-gray-50"
          >
            <h3 className="text-md font-semibold mb-2">{index + 1}.</h3>
            <ReactQuill
              value={q.question_text}
              readOnly={true}
              theme="bubble"
              className="mb-4 text-sm"
            />

            {(q.type === "single" || q.type === "multiple") &&
              q.choices.length > 0 && (
                <>
                  {q.type === "single" ? (
                    <ResponsiveContainer width="100%" height={250}>
                      <PieChart>
                        <Pie
                          data={q.choices}
                          dataKey="count"
                          nameKey="choice_text"
                          outerRadius={80}
                          label={({ name }) =>
                            name.length > 20
                              ? name.substring(0, 17) + "..."
                              : name
                          }
                        >
                          {q.choices.map((_, i) => (
                            <Cell key={i} fill={COLORS[i % COLORS.length]} />
                          ))}
                        </Pie>
                        <Legend
                          layout="horizontal"
                          verticalAlign="bottom"
                          align="center"
                        />
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  ) : (
                    <ResponsiveContainer width="100%" height={250}>
                      <BarChart
                        layout="vertical"
                        data={q.choices.map((c) => ({
                          ...c,
                          choice_text:
                            c.choice_text.length > 30
                              ? c.choice_text.substring(0, 27) + "..."
                              : c.choice_text,
                        }))}
                      >
                        <XAxis type="number" />
                        <YAxis dataKey="choice_text" type="category" />
                        <Bar dataKey="count">
                          {q.choices.map((_, i) => (
                            <Cell key={i} fill={COLORS[i % COLORS.length]} />
                          ))}
                        </Bar>
                        <Tooltip
                          formatter={(value, name) => [`${value}`, name]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  )}
                </>
              )}

            {q.type === "open" && q.responses && (
              <ul className="list-disc list-inside text-sm mt-2">
                {q.responses.length > 0 ? (
                  q.responses.map((resp, i) => <li key={i}>{resp}</li>)
                ) : (
                  <li className="italic text-gray-500">Aucune réponse</li>
                )}
              </ul>
            )}
          </div>
        ))}

        <div className="flex justify-center mt-4">
          <Button
            text="Fermer"
            icon={FaTimes}
            onClick={onClose}
            className="gap-2"
          />
        </div>
      </div>
    </div>
  );
};

export default VoteResultsModal;
